import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';

export interface IFifthWheel {
  id?: number;
  identificationCode?: string | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<IFifthWheel> = {};
